/**
 * @generated SignedSource<<8bf7aa5ff798d4c9acf629322226b1f9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type defaultLayoutAdminUserQuery$variables = Record<PropertyKey, never>;
export type defaultLayoutAdminUserQuery$data = {
  readonly isAdminUser: boolean;
};
export type defaultLayoutAdminUserQuery = {
  response: defaultLayoutAdminUserQuery$data;
  variables: defaultLayoutAdminUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAdminUser",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "defaultLayoutAdminUserQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "defaultLayoutAdminUserQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "1928dba924ade23bdebfbf65a8087bc1",
    "id": null,
    "metadata": {},
    "name": "defaultLayoutAdminUserQuery",
    "operationKind": "query",
    "text": "query defaultLayoutAdminUserQuery {\n  isAdminUser\n}\n"
  }
};
})();

(node as any).hash = "ccef3d3aaf761d2c35c314b4fe4d5362";

export default node;
